<template lang="pug">
    header.global_header
        .inner
            Logo
            GlobalNavigation
</template>

<script>
import Logo from '@/components/PublicLogo.vue'
import GlobalNavigation from '@/components/PublicGlobalNavigation.vue'

export default {
    components: {
        Logo,
        GlobalNavigation
    }
}
</script>